// ABOUTME: Smart wrapper for the Order Cancellation Lead Time entity — owns useOrderCancellationLeadTimeEntity.
// ABOUTME: Reuses OrderIntakeLeadTimeForm with its own key/data-cy so the page no longer branches per entity.
import React from 'react'

import {useOrderCancellationLeadTimeEntity} from '../hooks/useOrderCancellationLeadTimeEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {OrderIntakeLeadTimeForm} from './OrderIntakeLeadTimeForm'

export const OrderCancellationLeadTimeEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions, nonBusinessDays} =
    useOrderCancellationLeadTimeEntity({
      countryId: ctx.countryId,
      businessLine: ctx.businessLine,
      scopeId: ctx.selectedScopeId,
      pendingScope: ctx.pendingScope,
      rootScopeId: ctx.rootScopeId,
    })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <OrderIntakeLeadTimeForm
      key={`order-cancellation-lead-time-${ctx.selectedScopeId ?? 'none'}-${ctx.formResetKey}`}
      config={config}
      isReadOnly={ctx.isReadOnly}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      distanceUomOptions={ctx.leadTimeDistanceUomOptions ?? config.distanceUomOptions}
      leadTimeOptions={ctx.leadTimeFormOptions}
      nonBusinessDays={nonBusinessDays}
      data-cy="order-cancellation-lead-time-form"
    />
  )
}
